
export default function BrandValues() {
  const values = [
    {
      icon: 'ri-eye-line',
      title: '品牌愿景',
      subtitle: 'Brand Vision',
      content: '让科学可持续的体重管理，成为一种轻松的日常生活方式',
      color: 'from-[#847eba] to-[#9d85d1]'
    },
    {
      icon: 'ri-heart-3-line', 
      title: '品牌使命',
      subtitle: 'Brand Mission',
      content: '通过科学、有趣、无压力的产品与体验，帮助用户从内到外获得身体的轻盈和心理的轻松',
      color: 'from-[#9d85d1] to-[#a3c1c3]'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '品牌理念', 
      subtitle: 'Brand Philosophy',
      content: '不再贩卖身材的"焦虑"，而是倡导身体和心理的"快乐"；不再强调"快结果"，而是赋能"轻过程"',
      color: 'from-[#a3c1c3] to-[#b8d4c7]'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
            品牌价值体系
          </h2>
          <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            基于科学研究的三位一体价值体系，为用户提供全方位的轻松体验
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center group">
              <div className={`w-16 lg:w-20 h-16 lg:h-20 mx-auto mb-6 lg:mb-8 bg-gradient-to-br ${value.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${value.icon} text-xl lg:text-2xl text-white`}></i>
              </div>
              
              <div className="mb-4 lg:mb-6">
                <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-2">
                  {value.title}
                </h3>
                <p className="text-xs lg:text-sm text-[#847eba] font-medium mb-4 lg:mb-6">
                  {value.subtitle}
                </p>
                <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                  {value.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
